"use strict";export default":root{--_ui5_content_density:cozy}.sapUiSizeCompact,.ui5-content-density-compact,[data-ui5-compact-size]{--_ui5_content_density:compact}";
//# sourceMappingURL=SystemCSSVars.css.js.map
